var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7435 0.571411C10.4136 0.568736 10.0951 0.691263 9.85204 0.914268L6.00004 4.55884L2.14804 0.918554C1.90572 0.695254 1.58827 0.571289 1.25876 0.571289C0.929242 0.571289 0.611786 0.695254 0.36947 0.918554C0.252941 1.02535 0.159895 1.15521 0.0962414 1.2999C0.0325874 1.44458 -0.000282997 1.60092 -0.000283004 1.75898C-0.000283011 1.91705 0.0325874 2.07339 0.0962414 2.21807C0.159895 2.36275 0.252941 2.49261 0.36947 2.59941L5.11118 7.0797C5.35252 7.30394 5.66975 7.42857 5.99918 7.42857C6.32862 7.42857 6.64585 7.30394 6.88718 7.0797L11.6306 2.59941C11.7471 2.49261 11.8402 2.36275 11.9038 2.21807C11.9675 2.07339 12.0004 1.91705 12.0004 1.75898C12.0004 1.60092 11.9675 1.44458 11.9038 1.2999C11.8402 1.15522 11.7471 1.02535 11.6306 0.918554C11.3898 0.694262 11.0726 0.570131 10.7435 0.571411",
    fill: "#616D7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.0b092bd751dc4f4b543da692d9546bb2.svg";
export { ForwardRef as ReactComponent };